import { gql } from '@apollo/client'

export const GET_CHARTER_BOAT_CONFIGS = gql`
    query GetCharterBoatConfigs($page: PageInput!, $boat_id: String, $from_date: String, $to_date: String) {
        getCharterBoatConfigs(page: $page, boat_id: $boat_id, from_date: $from_date, to_date: $to_date) {
            code
            success
            message
            configurations {
                id
                boat {
                    id
                    name {
                        en
                        ar
                    }
                }
                from_date
                to_date
                base_price
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
            total_count
        }
    }
`

export const GET_CHARTER_BOAT_CONFIG = gql`
    query GetCharterBoatConfig($id: String!) {
        getCharterBoatConfig(id: $id) {
            code
            success
            message
            configuration {
                id
                boat_id
                from_date
                to_date
                base_price
                status_code
            }
        }
    }
`

export const GET_BOATS_FOR_CHARTER = gql`
    query GetBoatsForCharter {
        getBoatsForCharter {
            code
            success
            message
            boats {
                id
                name {
                    en
                    ar
                }
            }
        }
    }
`

export const GET_CONFIG_STATUS_LOOKUP = gql`
    query GetConfigStatusLookup {
        getConfigStatusLookup {
            code
            success
            message
            statuses {
                code
                description {
                    en
                    ar
                }
            }
        }
    }
`

export const GET_CHARTER_BOAT_CONFIGS_LIST = gql`
    query GetCharterBoatConfigs($page: PageInput!, $filter: CharterBoatConfigFilterInput!) {
        getCharterBoatConfigs(page: $page, filter: $filter) {
            code
            success
            message
            total_count
            charter_boat_configs {
                config_id
                boat_id
                boat {
                    id
                    name {
                        en
                        ar
                    }
                    details {
                        safety_equipment {
                            code
                            description {
                                en
                                ar
                            }
                        }
                        images {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                        features_amenities {
                            code
                            description {
                                en
                                ar
                            }
                        }
                        boat_type {
                            code
                            description {
                                en
                                ar
                            }
                        }
                    }
                    status {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    seat_layout {
                        layout_id
                        layout_key
                        num_columns
                        num_rows
                        seats_config {
                            seats {
                                status {
                                    code
                                    description {
                                        en
                                        ar
                                    }
                                }
                                seat_number
                                row
                                column
                            }
                        }
                        description {
                            en
                            ar
                        }
                    }
                }
                from_date
                to_date
                price {
                    amount
                    currency
                }
                status_code
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            }
        }
    }
`